var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0.7856 0.8058 505.5029 505.8422",
      "width": "200",
      "height": "200"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "rgb(33, 150, 243)"
    },
    attrs: {
      "cx": "-1191",
      "cy": "-660.24",
      "r": "811.382",
      "transform": "matrix(0.31150737157181757, 0, 0, 0.3117164575609852, 624.5423269005332, 459.5345359617046)"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "2.56",
      "fill": "rgb(42, 59, 79)"
    },
    attrs: {
      "d": "M -1323.2 -945.01 L -633.27 -945.01 C -595.17 -945.01 -564.28 -914.11 -564.28 -876.01 L -564.28 -48.161 C -564.28 -10.061 -595.17 20.829 -633.27 20.829 L -1323.2 20.829 C -1361.3 20.829 -1392.2 -10.061 -1392.2 -48.161 L -1392.2 -876.01 C -1392.2 -914.11 -1361.3 -945.01 -1323.2 -945.01 Z",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56"
    },
    attrs: {
      "x": "-1288.7",
      "y": "-841.51",
      "width": "620.898",
      "height": "55.191",
      "fill": "#FFFFFF",
      "opacity": "0.8",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56"
    },
    attrs: {
      "x": "-1288.7",
      "y": "-703.51",
      "width": "482.921",
      "height": "41.391",
      "fill": "#FFFFFF",
      "opacity": "0.8",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56"
    },
    attrs: {
      "x": "-1288.7",
      "y": "-600.11",
      "width": "551.912",
      "height": "41.391",
      "fill": "#FFFFFF",
      "opacity": "0.8",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56"
    },
    attrs: {
      "x": "-1288.7",
      "y": "-496.61",
      "width": "448.427",
      "height": "41.391",
      "fill": "#FFFFFF",
      "opacity": "0.8",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56"
    },
    attrs: {
      "x": "-1288.7",
      "y": "-393.1",
      "width": "517.418",
      "height": "41.391",
      "fill": "#FFFFFF",
      "opacity": "0.8",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "2.56",
      "fill": "rgb(50, 75, 94)"
    },
    attrs: {
      "x": "-1323.2",
      "y": "-945.01",
      "width": "68.987",
      "height": "965.845",
      "transform": "matrix(0.24804700911045074, 0, 0, 0.24804700911045074, 497.591552734375, 366.2369689941407)"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }